// import { ref, reactive } from 'vue'
import qc from 'qc'
import {
  resourceToNodeMapModel,
  ResourcePoolItem,
  ResourceCategory,
  LibInfo,
} from './type'
import {
  isDragonBone,
  isVideo,
  isImage,
  isAudio,
  isSequenceFrame,
} from '@ps/bridge/qc/base'
import {
  getFileName,
  removeFileExtension,
  replaceJpegToJpg,
} from '@com/utils/file'
import _ from 'lodash'
import store from '@ps/store'
import { getFileExtension } from '@com/utils/file'
import { projectBasicPath } from '@ps/workbench/config'
// import { getVideoMetaData } from '@com/utils/video.js'
import assets from '@ps/bridge/qc/assets'
import * as editorScript from '@ps/bridge/qc/scripts/editor'
import { ResponseCode } from '@ps/utils/request'
import { addDataURIPrefix, addDataURIPrefixForFiles } from '@com/utils/base64'
import { dataURItoBlob } from '@com/utils/data-uri'
import { AssetRoute } from '@ps/utils/config'
import { createImageComponentBeforeUpdateImage } from '@ps/workbench/layer/image'
import { updateImageComponent } from '@ps/workbench/resource-manager/update-image-in-playable'
import nodePool from '@ps/bridge/qc/node-pool'
import { getFileNameWithoutExt, isParticleSystem } from '@ps/utils/game'
import iframe from '@ps/bridge/iframe/iframe'
import { getBlob } from '@ps/utils/base64-to-blob'
import { saveGlobalUrlMap } from '@ps/bridge/resource/global-url-map'
import { EventBus, Event } from '@ps/utils/event-bus'
import { readFile } from '@ps/api/editor/file'
import gameIframe from '@ps/bridge/iframe/iframe'
import * as bgScript from '@ps/bridge/qc/scripts/bg-config'
import { Message } from 'element-ui'
import i18n from '@ps/lang'
import { getLayoutData, updateLayoutData } from '@ps/bridge/qc/scripts/layout'
import { sortFileSrcList } from '@ps/workbench/resource-manager/uploader/xlz'
import { isIvPage } from '@ps/router/config'
import { emptyBrainByVideoNode } from '@ps/store/interactive-video/brain/brain'

const getRelateNodeByResourcePath = (path: string): qc.Node[] => {
  const resourceToNodePool =
    store.state.workspace.resourceManager.resourceToNodePool
  if (resourceToNodePool[path]) {
    return resourceToNodePool[path].map((uuid) => nodePool.find(uuid))
  }
  return []
}

export const getPoolItemRelateNodes = (item: ResourcePoolItem): qc.Node[] => {
  let nodes: qc.Node[] = []
  const temp = getPoolItemMainPath(item)
  temp.forEach((path) => {
    nodes = nodes.concat(getRelateNodeByResourcePath(path))
  })
  return nodes
}

export function getPoolItemMainPath(item: ResourcePoolItem) {
  if (item.paths && Array.isArray(item.paths)) {
    const temp = item.paths?.map((path) => {
      const aPath = path.replace(/^\//, '')
      if (item.type === ResourceCategory.IMAGE) {
        return pathSwitchBinPath(aPath)
      }
      return aPath
    })
    return temp
  }
  return []
}

const getPoolItemResourceLibData = (item: ResourcePoolItem) => {
  const infoPool = store.state.workspace.editorConfig.libDataPool
  const infos: any[] = []
  const paths = getPoolItemMainPath(item)
  paths.forEach((path) => {
    if (infoPool[path]) {
      infos.push(infoPool[path])
    }
  })
  if (infos.length > 0) {
    return infos[0]
  }
  return null
}

export const poolVideoGetConfigByPath = (path: string) => {
  const node = getRelateNodeByResourcePath(path)[0]
  // 互动视频编辑器不通过节点获取配置
  if (node && !isIvPage()) {
    return {
      name: node.name,
      width: node.width,
      height: node.height,
      sourceVideoUrl: node.Video.sourceVideoUrl,
      videoCoverUrl: node.Video.videoCoverUrl,
      videoUrl: _.get(node, 'Video.videoUrl'),
      audioUrl: _.get(node, 'Video.audioUrl'),
      sourceVideoDuration: _.get(node, 'Video.sourceVideoDuration'),
      duration: _.get(node, 'data.$data.duration'),
      size: _.get(node, 'data.$data.size'),
      stime: _.get(node, 'Video.clipStartTime'),
    }
  }
  const info = store.state.workspace.editorConfig.libDataPool[path]
  if (info) {
    return {
      name: info.name,
      ...info.data,
    }
  }
  return null
}

export const poolAudioGetConfigByPath = (path: string) => {
  const node = getRelateNodeByResourcePath(path)[0]
  if (node) {
    return {
      file_url: node.AudioNode.sourceAudioUrl,
      file_size: node.AudioNode.size || 0,
      name: node.name,
      path: node.AudioNode.audioUrl,
      duration:
        _.get(node, 'AudioNode.clipEndTime') -
        _.get(node, 'AudioNode.clipStartTime'),
      sourceAudioDuration: _.get(node, 'AudioNode.sourceAudioDuration'),
      stime: _.get(node, 'AudioNode.clipStartTime'),
    }
  }
  const info = store.state.workspace.editorConfig.libDataPool[path]
  if (info) {
    return {
      name: info.name,
      ...info.data,
    }
  }
  return null
}

export const getVideoConfigByOriginPath = (path: string) => {
  const libDataPool = store.state.workspace.editorConfig.libDataPool
  let temp = null
  for (const key in libDataPool) {
    if (key.indexOf('mp4') !== -1) {
      const info = libDataPool[key]
      if (info.data.sourceVideoUrl === path) {
        temp = {
          name: info.name,
          ...info.data,
        }
      }
    }
  }
  return temp
}

const getMetaByPath = (path: string) => {
  const name = getFileName(path)
  const ext = getFileExtension(path)
  const pathArray = path.replace(`.${ext}`, '').split('_')
  return {
    binUUID: pathArray[pathArray.length - 1],
  }
}

export const getPooItemName = (item: ResourcePoolItem) => {
  const path = getPoolItemMainPath(item)[0] as string
  const relateNodes = getPoolItemRelateNodes(item) as qc.Node[]
  const pool = store.state.workspace.editorConfig.libDataPool
  if (pool[path]) {
    return pool[path].name
  } else if (relateNodes && relateNodes.length) {
    const node = relateNodes[0] as qc.Node
    return node.name
  }
  const name = getFileName(path)
  const ext = getFileExtension(path)
  return name.replace(`.${ext}`, '')
}

function pathSwitchBinPath(path: string) {
  const ext = getFileExtension(path)
  return path.replace(`.${ext}`, '.bin')
}

const poolDragonBoneGetConfigByItem = async (item: ResourcePoolItem) => {
  const binPath = getPoolItemMainPath(item)[0] as string
  const binUUID = getMetaByPath(binPath).binUUID as string
  await assets.load({
    uuid: binUUID,
    url: binPath,
    override: true,
  })
  // 保存资源列表
  await saveGlobalUrlMap({
    projectKey: store.state.workspace.pid,
    uuid2url: assets.uuid2UrlConf,
  })
  const fileName = binPath
    .split('/')
    .find((name) => name.indexOf('lg_') !== -1) as string
  return {
    path: binPath,
    binUUID,
    name: fileName.replace('lg_', ''),
  }
}

// 记录删除资源列表
export const deleteResourceAction = {
  addResource: (path: string) => {
    store.dispatch('workspace/editorConfig/addDeleteResourcePool', {
      path,
    })
  },
  removeResource: (path: string) => {
    store.dispatch('workspace/editorConfig/removeDeleteResourcePool', {
      path,
    })
  },
  // 项目初始化阶段，读取删除资源列表，清理冗余资源
  clearResoruce: () => {
    // const deleteResourcePool =
    //   store.state.workspace.editorConfig.deleteResourcePool
    // deleteResourcePool.forEach((path) => {
    //   // 删除资源
    // })
  },
}

const loadProjectAssetsByPath = async (binPath: string) => {
  const binUUID = getMetaByPath(binPath).binUUID as string
  await assets.load({
    uuid: binUUID,
    url: binPath,
    override: true,
  })
  // 保存资源列表
  await saveGlobalUrlMap({
    projectKey: store.state.workspace.pid,
    uuid2url: assets.uuid2UrlConf,
  })
}

export const sortXlzByFileName = (files: string[]) => {
  return _.sortBy(
    (files || []).filter((path) => path.indexOf('.bin') === -1),
    (o) => {
      const indexStr = o.split('_')[o.split('_').length - 1]
      return indexStr
    },
  )
}

export const poolAction = {
  add: async (item: ResourcePoolItem, targetNode?: qc.Node, callback: any) => {
    const poolTabData = store.state.workspace.resourceManager.poolTabData
    if (item.type === ResourceCategory.IMAGE) {
      const path = getPoolItemMainPath(item)[0] as string // 选取第一个路径
      const fileName = getFileName(path)
      const resourcePath = path.replace(fileName, '')
      const binUUID = getMetaByPath(path).binUUID
      const name = getFileName(getPooItemName(item), true)
      await loadProjectAssetsByPath(pathSwitchBinPath(path))

      const data: {
        isPool: boolean
        file: {
          ext: string
          name: string
          path: string
          uuid: string | undefined
        }[]
        fileName: string
        targetNode?: qc.Node
        rename?: string
      } = {
        isPool: true,
        file: [
          {
            ext: `.${getFileExtension(path)}`,
            name: `${fileName}`,
            path: resourcePath,
            uuid: binUUID,
          },
          {
            ext: '.bin',
            name: `${getFileName(path, true)}.bin`,
            path: resourcePath,
            uuid: binUUID,
          },
        ],
        fileName: name,
      }

      // 玩法组件使用资源弹窗，指定插入节点资源
      if (poolTabData.playComponentResource && poolTabData.targetNode) {
        data.targetNode = nodePool.find(poolTabData.targetNode.uuid)
      } else if (targetNode) {
        // 资源池指定目标的添加操作
        data.targetNode = nodePool.find(targetNode.uuid)
      }
      if (poolTabData.rename) {
        data.rename = poolTabData.rename
      }
      // 资源池添加图片
      const imgNode = await store.dispatch(
        'workspace/game/addImageToScene',
        data,
      )
      // 添加资源添加回调
      const actionCallBack = poolTabData.callback || callback
      if (actionCallBack) {
        actionCallBack(imgNode)
      }
      if (poolTabData.playComponentResource && poolTabData.targetNode) {
        store.commit('workspace/resourceManager/closeLibDialog')
        EventBus.$emit(Event.REFRESHLAYER)
      } else if (targetNode) {
        EventBus.$emit(Event.REFRESHLAYER)
      }
      setTimeout(() => {
        console.log('资源池刷新')
        EventBus.$emit(Event.RESOURCE_POOL_REFRESH)
      }, 500)
      return imgNode
    } else if (item.type === ResourceCategory.VIDEO) {
      // 如果到达上限，不允许添加视频
      const limitStatus = await store.dispatch(
        'workspace/game/video/getUpperLimitStatus',
      )
      // 添加资源模式下，才限制视频
      if (limitStatus) {
        Message({
          message: i18n.t(
            'workbench.resourceManagers.videoUploader.sceneSupport',
          ) as string,
          type: 'error',
        })
        return
      }
      // 清理返回路径中前面的斜杠
      const path = getPoolItemMainPath(item)[0] as string
      await store.dispatch(
        'workspace/game/video/addVideoNode',
        poolVideoGetConfigByPath(path),
      )
    } else if (item.type === ResourceCategory.AUDIO) {
      // 清理返回路径中前面的斜杠
      const path = getPoolItemMainPath(item)[0] as string
      // 资源池添加音频
      await store.dispatch(
        'workspace/game/audio/addAudioNode',
        poolAudioGetConfigByPath(path),
      )
    } else if (item.type === ResourceCategory.DRAGON_BONE) {
      const data = await poolDragonBoneGetConfigByItem(item)
      // 资源池添加龙骨
      store.dispatch('workspace/game/addDragonBone', {
        isPool: true,
        data,
      })
    } else if (item.type === ResourceCategory.SEQUENCE_FRAME) {
      // 获取序列帧文件夹中图片文件
      const files = sortFileSrcList(
        (item.files || []).filter((path) => path.indexOf('.bin') === -1),
      )
      // 获取资源路径
      const resourcePath = getPoolItemMainPath(item)[0] as string
      const data = {
        isPool: true,
        fileList: files.map((path) => `${resourcePath}${path}`),
        actionName: item.name,
        pid: store.state.workspace.pid,
        callback: ({ node, binList }) => {
          const fileList = binList.map((bin) => ({
            value: bin,
            src: `${projectBasicPath}${store.state.workspace.pid}/${bin.replace(
              /\.bin$/i,
              '.png',
            )}`,
          }))
          // originalResource 暂时用项目中的地址代替
          store.dispatch('workspace/editorConfig/updateTargetNodeConfig', {
            originalResource: fileList,
            resource: fileList,
            node,
          })
          if (node && poolTabData.rename) {
            node.name = poolTabData.rename
          }
          if (node && poolTabData.callback) {
            // 添加资源添加回调
            poolTabData.callback(node)
          }
          if (poolTabData.playComponentResource && poolTabData.targetNode) {
            store.commit('workspace/resourceManager/closeLibDialog')
            EventBus.$emit(Event.REFRESHLAYER)
          }
        },
      }

      // 擦除组件使用资源弹窗，指定插入节点资源
      if (poolTabData.playComponentResource && poolTabData.targetNode) {
        data.targetNode = nodePool.find(poolTabData.targetNode.uuid)
      }

      await store.dispatch(
        'workspace/game/sequenceManager/addSequenceFrame',
        data,
      )
      // 资源池添加序列帧
    } else if (item.type === ResourceCategory.PARTICLE) {
      // 粒子资源禁用添加场景
    }
    setTimeout(() => {
      EventBus.$emit(Event.RESOURCE_POOL_REFRESH)
    }, 500)
  },
  addImageToProject: async (data: {
    resource: any
    isFromAssetResourceLibrary: boolean
  }) => {
    const { resource, isFromAssetResourceLibrary } = data
    const { file_url, name, id } = resource
    // 由于 name 可能有后缀和没后缀的情况，所以先移除再添加
    // 由于引擎不支持 jpeg 后缀，所以需要将 jpeg 改为 jpg
    const fileName = replaceJpegToJpg(
      `${removeFileExtension(name)}.${getFileExtension(file_url)}`,
    ).toLowerCase()
    const res = await store.dispatch(
      'workspace/resourceManager/readComponent',
      {
        id,
        base64: 1,
        resSource: isFromAssetResourceLibrary ? 'asset' : '',
        notCommonResource: true,
      },
    )
    if (res.code !== ResponseCode.Success) {
      // 资源丢失, 文案提示
      if (res.code === ResponseCode.AssetNotExists) {
        // this.$editMessage.error(
        //   this.$t(
        //     'workbench.resourceManagers.addResourceToPlayable.editError[2]',
        //   ),
        // )
      } else {
        // this.$editMessage.error(res.msg)
      }
      return
    }

    const dataURL = addDataURIPrefix(
      res.data.file_base64,
      getFileExtension(file_url),
    )
    const file = dataURItoBlob(dataURL)
    // 补name，引擎只认小写后缀
    // @ts-ignore
    file.name = fileName

    const resourcePath = AssetRoute.GAME_ROOT
    const component = await createImageComponentBeforeUpdateImage({
      // @ts-ignore
      file,
      resourcePath,
    })
    // await loadProjectAssetsByPath(pathSwitchBinPath(path))
    await updateImageComponent({
      // @ts-ignore
      data: {
        ...component,
        fileName: fileName,
      },
      addImageToConfig: true,
      resourcePath,
      nodes: [],
      isUpdateImage: false,
      isSetLibData: true,
    })
  },
  updatePoolResourceByResource: async (data: {
    resource: any
    isFromAssetResourceLibrary: boolean
    poolItem: ResourcePoolItem
  }) => {
    const { resource, isFromAssetResourceLibrary, poolItem } = data
    // 根据资源池资源获取关联节点
    const relateNodes = getPoolItemRelateNodes(poolItem)
    if (relateNodes.length === 0) {
      console.log('没有关联节点')
      return false
    }
    if (poolItem.type === ResourceCategory.IMAGE) {
      const { file_url, name, id } = resource
      // 由于 name 可能有后缀和没后缀的情况，所以先移除再添加
      // 由于引擎不支持 jpeg 后缀，所以需要将 jpeg 改为 jpg
      const fileName = replaceJpegToJpg(
        `${removeFileExtension(name)}.${getFileExtension(file_url)}`,
      ).toLowerCase()
      const res = await store.dispatch(
        'workspace/resourceManager/readComponent',
        {
          id,
          base64: 1,
          resSource: isFromAssetResourceLibrary ? 'asset' : '',
        },
      )
      if (res.code !== ResponseCode.Success) {
        // 资源丢失, 文案提示
        if (res.code === ResponseCode.AssetNotExists) {
          // this.$editMessage.error(
          //   this.$t(
          //     'workbench.resourceManagers.addResourceToPlayable.editError[2]',
          //   ),
          // )
        } else {
          // this.$editMessage.error(res.msg)
        }
        return
      }

      const dataURL = addDataURIPrefix(
        res.data.file_base64,
        getFileExtension(file_url),
      )
      const file = dataURItoBlob(dataURL)
      // 补name，引擎只认小写后缀
      // @ts-ignore
      file.name = fileName

      const resourcePath = AssetRoute.GAME_ROOT
      const component = await createImageComponentBeforeUpdateImage({
        // @ts-ignore
        file,
        resourcePath,
      })
      await updateImageComponent({
        // @ts-ignore
        data: {
          ...component,
          fileName: fileName,
        },
        addImageToConfig: true,
        resetAnotherLayout: true,
        resourcePath,
        nodes: relateNodes,
        isSetLibData: true,
      })
      // store.dispatch('workspace/game/addFilter', {
      //   node: node,
      //   filters: {
      //     hue: 0,
      //     saturation: 0,
      //     luminance: 0,
      //     blur: 0,
      //   },
      // })
    } else if (poolItem.type === ResourceCategory.VIDEO) {
      const {
        id,
        width,
        height,
        name,
        file_url,
        duration,
        icon_url,
        thumb_url,
      } = resource

      // 添加资源到项目
      const params: any = {}
      params.asset_id = id
      if (isFromAssetResourceLibrary) {
        params.from = 3
      }
      const projectPath = await store.dispatch(
        'workspace/game/video/addVideoResourceToProject',
        params,
      )
      const videoNodeConfig = {
        name: getFileNameWithoutExt(name),
        width: width,
        height: height,
        sourceVideoUrl: _.get(projectPath, 'data.origin.path')
          ? _.get(projectPath, 'data.origin.path')
          : file_url,
        videoCoverUrl: icon_url || thumb_url,
        videoUrl: _.get(projectPath, 'data.video.path'),
        audioUrl: _.get(projectPath, 'data.audio.path'),
        sourceVideoDuration: duration,
        duration: _.get(projectPath, 'data.video.duration'),
        size: _.get(projectPath, 'data.video.file_size'),
      }
      store.dispatch('workspace/game/video/toggleVideoNode', {
        ...videoNodeConfig,
        node: relateNodes,
      })
    } else if (poolItem.type === ResourceCategory.AUDIO) {
      //
      const isFromCommonResourceLibrary = false
      const { id, name, file_url } = resource
      // 添加资源到项目中,新资源库增加from=2
      const params = {
        asset_id: id,
        from: 2,
      }
      if (!isFromCommonResourceLibrary) {
        // @ts-ignore
        delete params.from
      }
      if (isFromAssetResourceLibrary) {
        params.from = 3
      }
      const { path, file_size, duration, origin } = await store.dispatch(
        'workspace/game/audio/addAudioResourceToProject',
        params,
      )
      if (!store.state.workspace.game.iframeWindow.ps.AudioNode) {
        return
      }
      let fileOriginPath = file_url
      if (origin && origin.path) {
        fileOriginPath = `${origin.path}`
      }
      await store.dispatch('workspace/game/audio/toggleAudioNode', {
        file_url: fileOriginPath,
        file_size,
        path,
        name,
        duration,
        node: relateNodes,
      })
    } else if (poolItem.type === ResourceCategory.DRAGON_BONE) {
      //
      const qc = iframe.qc
      if (qc && !qc.dragonBones) {
        // this.$editMessage.info('当前模板不支持添加龙骨节点')
        return
      } else if (poolItem.type !== resource.creative_type) {
        Message({
          message: i18n.t('basic.upload.fileStatus.invalid') as string,
          type: 'error',
        })
        return
      }

      const params: any = {}
      params.id = resource.id
      if (isFromAssetResourceLibrary) {
        params.resSource = 'asset'
      }
      const ret = await store.dispatch(
        'workspace/resourceManager/readComponent',
        { ...params },
      )
      await store.dispatch('workspace/game/replaceDragonBone', {
        data: ret.data,
        node: relateNodes,
      })
    } else if (poolItem.type === ResourceCategory.SEQUENCE_FRAME) {
      if (resource.creative_type) {
        if (resource.creative_type !== poolItem.type) {
          Message({
            message: i18n.t('basic.upload.fileStatus.invalid') as string,
            type: 'error',
          })
          return
        }
      } else if (resource.type && resource.type !== 3) {
        Message({
          message: i18n.t('basic.upload.fileStatus.invalid') as string,
          type: 'error',
        })
        return
      }
      const { id } = resource
      const params: any = {
        id,
      }
      if (isFromAssetResourceLibrary) {
        params.resSource = 'asset'
      }
      const ret = await store.dispatch(
        'workspace/resourceManager/readComponent',
        params,
      )
      // 获取资源路径
      // const resourcePath = getPoolItemMainPath(poolItem)[0] as string
      // 转换成 blob 对象再调用 addSequenceFrame，（优化 addSequenceFrame 支持 base64，而不是 file 对象）
      let files: any = addDataURIPrefixForFiles(ret.data.files)
      // @ts-ignore
      files = files.map((item, index) => {
        const blob = getBlob(item.data)
        // 由于引擎不支持 jpeg 后缀，所以需要将 jpeg 改为 jpg
        const name = replaceJpegToJpg(files[index].name)
        // @ts-ignore
        blob.name = name
        return {
          raw: blob,
          name,
        }
      })
      await store.dispatch(
        'workspace/game/sequenceManager/toggleSequenceFrame',
        {
          fileList: files,
          pid: store.state.workspace.pid,
          node: relateNodes,
        },
      )
      // 刷新激活节点样式
      await store.dispatch('workspace/game/refreshActiveNode')
      // ps无序列帧替换功能，需要单独开发
    } else if (poolItem.type === ResourceCategory.PARTICLE) {
      // 无粒子替换功能
    }
    EventBus.$emit(Event.RESOURCE_POOL_REFRESH)
  },
  /**
   * 通过资源池资源批量更新节点资源
   * @param resource 选中项目资产
   * @param nodes 需要更新的节点列表
   * @param type 资源类型
   */
  updatePoolResourceByPoolItem: async (data: {
    resource: ResourcePoolItem
    nodes: qc.Node[]
    type: ResourceCategory
    subCategory?: string
  }) => {
    const { resource, type, nodes, subCategory } = data
    // 资源项目路径
    const pickPath = getPoolItemMainPath(resource)[0] as string
    if (type === ResourceCategory.IMAGE && subCategory === 'bg') {
      const ext = getFileExtension(resource.paths[0])
      const base64Img = await readFile({
        pid: store.state.workspace.pid,
        path: pickPath.replace('.bin', `.${ext}`),
        base64: 1,
      })
      const dataURL = addDataURIPrefix(base64Img, ext)
      const file = dataURItoBlob(dataURL)
      await store.dispatch('workspace/globalConfig/updateBgImage', {
        file,
        dataURL,
      })
      const gamePlay = store.state.workspace.game.gamePlay
      await store.dispatch('workspace/game/addBgFilter', {
        node: gamePlay,
        filters: {
          hue: 0,
          saturation: 0,
          luminance: 0,
          blur: 0,
        },
      })
      const globalConfig = bgScript.getScript(gamePlay, false)
      // 为啥要用这个地址，因为私域地址会有失效的可能
      const bgUrl = globalConfig.bgUrl
      await store.dispatch('workspace/editorConfig/updateTargetNodeConfig', {
        originalResource: bgUrl,
        resource: bgUrl,
        bg: true,
      })
    } else if (type === ResourceCategory.IMAGE) {
      let nodeList = nodes
      const poolTabData = store.state.workspace.resourceManager.poolTabData
      const path = getPoolItemMainPath(resource)[0] as string // 选取第一个路径
      await loadProjectAssetsByPath(pathSwitchBinPath(path))
      const setImagePromise: any[] = []
      // 擦除组件使用资源弹窗，指定插入节点资源
      if (poolTabData.targetNode) {
        nodeList = [nodePool.find(poolTabData.targetNode.uuid)]
      }
      nodeList.forEach((node) => {
        setImagePromise.push(
          store.dispatch('workspace/game/setImage', {
            resourceUuid: assets.getUuidByUrl(pickPath),
            nodeUuid: node ? node.uuid : '',
            resetImageAfterAdd: true,
            resetAnotherLayout: true,
            addImageToConfig: true,
            record: true,
          }),
        )
      })
      await Promise.all(setImagePromise)
      if (poolTabData.targetNode) {
        store.commit('workspace/resourceManager/closeLibDialog')
        EventBus.$emit(Event.REFRESHLAYER)
      }
      store.state.workspace.resourceManager.onReplaced &&
        store.state.workspace.resourceManager.onReplaced()
      console.log('图片更新成功!')
    } else if (type === ResourceCategory.VIDEO) {
      // 清理返回路径中前面的斜杠
      const path = getPoolItemMainPath(resource)[0] as string
      const setVideoPromise: any[] = []
      nodes.forEach((node) => {
        setVideoPromise.push(
          store.dispatch('workspace/game/video/toggleVideoNode', {
            ...poolVideoGetConfigByPath(path),
            node,
          }),
        )
      })
      await Promise.all(setVideoPromise)
    } else if (type === ResourceCategory.AUDIO && subCategory === 'bgm') {
      const path = getPoolItemMainPath(resource)[0] as string
      const config = poolAudioGetConfigByPath(path)
      const data = {
        sourceAudioUrl: config.file_url,
        size: config.file_size || 0,
        audioUrl: config.path,
        sourceAudioDuration: config.duration,
      }
      await store.commit('workspace/game/bgm/setBgmBehConfig', data)
      await store.commit('workspace/game/bgm/setBgmConfig', data)
      await store.dispatch('workspace/editorConfig/saveBgmConfig', {
        value: 1,
        delete: 0,
      })
    } else if (type === ResourceCategory.AUDIO) {
      const path = getPoolItemMainPath(resource)[0] as string
      const setAudioPromise: any[] = []
      nodes.forEach((node) => {
        setAudioPromise.push(
          store.dispatch('workspace/game/audio/toggleAudioNode', {
            ...poolAudioGetConfigByPath(path),
            node,
          }),
        )
      })
      await Promise.all(setAudioPromise)
    } else if (type === ResourceCategory.DRAGON_BONE) {
      if (type !== resource.type) {
        Message({
          message: i18n.t('basic.upload.fileStatus.invalid') as string,
          type: 'error',
        })
        return
      }
      // 龙骨资源路径bin文件路径唯一
      const setDragonBonePromise: any[] = []
      nodes.forEach(async (node) => {
        const data = await poolDragonBoneGetConfigByItem(resource)
        setDragonBonePromise.push(
          store.dispatch('workspace/game/replaceDragonBone', {
            isPool: true,
            data,
            node,
          }),
        )
      })
      await Promise.all(setDragonBonePromise)
      // 刷新激活节点样式
      await store.dispatch('workspace/game/refreshActiveNode')
    } else if (type === ResourceCategory.SEQUENCE_FRAME) {
      if (type !== resource.type) {
        Message({
          message: i18n.t('basic.upload.fileStatus.invalid') as string,
          type: 'error',
        })
        return
      }
      const getSequenceFrameBinList = (resource: ResourcePoolItem) => {
        const path = getPoolItemMainPath(resource)[0] as string
        return resource.files
          ?.filter((val) => val.indexOf('bin') !== -1)
          ?.map((val) => {
            return `${path}${val}`
          })
      }
      await store.dispatch(
        'workspace/game/sequenceManager/toggleSequenceFrame',
        {
          isPool: true,
          fileList: getSequenceFrameBinList(resource),
          pid: store.state.workspace.pid,
          node: nodes,
        },
      )
      // 刷新激活节点样式
      await store.dispatch('workspace/game/refreshActiveNode')
    }
    EventBus.$emit(Event.RESOURCE_POOL_REFRESH)
  },
  remove: async (item: ResourcePoolItem) => {
    const getRelateNode = () => {
      // 互动视频编辑器清空视频操作
      if (isIvPage() && item.type === ResourceCategory.VIDEO) {
        const brainData = _.cloneDeep(store.state.ivBrain.brainData)
        const toRemoves = emptyBrainByVideoNode(
          getPoolItemRelateNodes(item),
          brainData,
        )
        store.commit('ivBrain/updateBrainData', brainData)
        EventBus.$emit(Event.IV_BRAIN_CHANGE)
        return toRemoves.reduce((start, cur) => start.concat(cur), [])
      }
      return getPoolItemRelateNodes(item)
    }
    const relateNodes = getRelateNode()
    await store.dispatch('workspace/game/removeNode', {
      nodes: relateNodes,
      poolItem: item,
    })
  },
}

export const libDataPool = {
  setLibData: (path: string, data: LibInfo) => {
    store.dispatch('workspace/editorConfig/updateLibData', {
      path,
      data,
    })
    deleteResourceAction.removeResource(path)
  },
  removeLibData: (path: string) => {
    store.dispatch('workspace/editorConfig/removeLibData', {
      path,
    })
  },
}

export function getNodeMainResourcePath(node: qc.Node) {
  if (isImage(node)) {
    return _.get(node, 'texture.atlas.url', '')
  }
  if (isVideo(node)) {
    return _.get(node, 'Video.videoUrl', '')
  }
  if (isAudio(node)) {
    return _.get(node, 'AudioNode.audioUrl', '')
  }
  if (isDragonBone(node)) {
    return _.get(node, 'texture.atlas.url', '')
  }
  if (isSequenceFrame(node)) {
    const mv = _.get(node, 'MovieClip', '')
    if (!mv.data || !mv.data[mv.defActionName]) {
      return ''
    }
    const allFrames = mv.data[mv.defActionName].split(',')
    const path = allFrames[0]
    const fileName = getFileName(path)
    return path.replace(fileName, '')
  }
  if (isParticleSystem(node)) {
    return _.get(node, 'texture.atlas.url', '')
  }
  return ''
}

export function cookNodeResourceMap(nodes: qc.Node): resourceToNodeMapModel {
  const map: resourceToNodeMapModel = {}
  const deleteResourcePool =
    store.state.workspace.editorConfig.deleteResourcePool
  const setMap = (path: string, item: qc.Node) => {
    if (map && map[path]) {
      map[path]?.push(item.uuid)
    } else {
      map[path] = [item.uuid]
    }
  }
  nodes.forEach((node: qc.Node) => {
    const url = getNodeMainResourcePath(node)
    if (url) {
      setMap(url, node)
    }
  })
  // 从资源清理池中清理
  // 1.存在映射节点
  for (const key in map) {
    if (deleteResourcePool.indexOf(key) > -1) {
      deleteResourceAction.removeResource(key)
    }
  }
  return map
}

export const defaultBgmResource = ['bm_bgm.mp3']
export const defaultBgResource = ['pb_bg.jpg']
export const defaultResource = [...defaultBgmResource, ...defaultBgResource]

export function filterResourcePoolItem(list: ResourcePoolItem[]) {
  return list.filter((item) => {
    const deleteResourcePool =
      store.state.workspace.editorConfig.deleteResourcePool
    // 过滤黑名单中文件，不展示到资源池
    const isRelatedResource = (item: ResourcePoolItem) => {
      // 资源关联游戏节点
      const relateNodes = getPoolItemRelateNodes(item)
      // 是否存在lib信息
      if (getPoolItemResourceLibData(item)) {
        return true
      }
      // 是否存在关联节点
      if (relateNodes.length > 0) {
        return true
      }
      return false
    }
    const blackList = [
      // 兜底占位文件
      'bm_bgm0.mp3',
      'pb_bg0.jpg',
      // 基础包项目转换生成的兼容文件，功能影响待定，暂不展示
      'pb_bg_origin',
      // 冗余背景图文件
      'eb_bg.jpg',
      // 空白模板中冗余文件
      'button1.png',
      'button2.png',
      // 轮播组件默认资源
      'carousel-arrow-left.png',
      'carousel-arrow-right.png',
      'carousel-image.png',
    ]
    // 未设置背景音乐和背景图，不展示到资源池
    if (!store.state.workspace.editorConfig.bg.value) {
      blackList.push('pb_bg.jpg')
    }
    if (!store.state.workspace.editorConfig.bgm.value) {
      blackList.push('bm_bgm.mp3')
    }
    if (blackList.some((val) => item.name.indexOf(val) !== -1)) {
      return false
    }
    // 删除映射表中的资源，不展示到资源池
    if (deleteResourcePool.includes(getPoolItemMainPath(item)[0])) {
      return false
    }
    if (defaultResource.some((val) => item.name.indexOf(val) !== -1)) {
      return true
    }
    // 图片
    if (item.type === ResourceCategory.IMAGE) {
      // 只展示存在关联关系资源
      return isRelatedResource(item)
    }
    // 视频
    if (
      item.type === ResourceCategory.VIDEO ||
      item.type === ResourceCategory.AUDIO
    ) {
      // 只展示存在关联关系资源
      return isRelatedResource(item)
    }
    if (item.type === ResourceCategory.DRAGON_BONE) {
      return true
    }
    if (item.type === ResourceCategory.SEQUENCE_FRAME) {
      return true
    }
    if (item.type === ResourceCategory.PARTICLE) {
      return true
    }
    return false
  })
}

export function handleResourcePoolItem(
  list: ResourcePoolItem[],
): ResourcePoolItem[] {
  return list.map((i) => {
    return { ...i, path: handleResourcePoolPaths(i.paths!)[0] }
  })
}

export function handleResourcePoolPaths(paths: string[]) {
  return paths.map((item) => {
    return item.replace('/', '')
  })
}
